import { render } from "./step-transfer-of-ownership.vue?vue&type=template&id=61f88f20"
import script from "./step-transfer-of-ownership.vue?vue&type=script&lang=ts"
export * from "./step-transfer-of-ownership.vue?vue&type=script&lang=ts"
script.render = render

export default script